'use client';

import React from 'react';
import { Message } from './types';

interface ReplyPreviewProps {
  message: Message;
  isMe: boolean;
}

export default function ReplyPreview({ message, isMe }: ReplyPreviewProps) {
  const senderName = message.senderId === 'me' ? 'You' : 'Ate Boni';
  const preview = message.text
    ? message.text.length > 60 ? message.text.slice(0, 57) + '…' : message.text :'📷 Photo';

  return (
    <div
      className="mx-2 mt-2 mb-0.5 rounded-lg px-2.5 py-1.5 cursor-pointer hover:opacity-80 transition-opacity"
      style={{
        borderLeft: '3px solid #2EA6FF',
        background: isMe ? 'rgba(255,255,255,0.12)' : 'rgba(46,166,255,0.1)',
      }}
      role="blockquote"
      aria-label={`Reply to ${senderName}`}
    >
      <p className="text-[12px] font-semibold leading-tight mb-0.5 truncate" style={{ color: '#2EA6FF' }}>
        {senderName}
      </p>
      <p className="text-[12.5px] leading-tight truncate" style={{ color: 'rgba(255,255,255,0.65)' }}>
        {preview}
      </p>
    </div>
  );
}